define([
	"dojo/_base/declare",
	"./Path"
], function(declare, PathMatrix) {

	return declare(PathMatrix, {
		// currently do not have functionality to filter in column matrix
		restrictQuery: true,

		/** @property {string} columnAssociation - association from path nodes to column node (required) */
		columnAssociation: "",

		/** @property {string} [columnAssociationPath] - path from row node to node containing column association */
		columnAssociationPath: null,

		/**
		 * @override
		 * Filter out nodes in path that are not related to the current column
		 */
		_filterNodes({cache}, {columnUrl}, nodes) {
			const {columnAssociation, columnAssociationPath} = this;

			return nodes.filter((node) => {
				const pathNode = cache.getPathNode(node, columnAssociationPath);
				return pathNode?.[columnAssociation] === columnUrl;
			});
		}
	});
});